import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferenceProteome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 32",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10.5 21.3c1.7 0 3-.2 3.7-.7.7-.4 1.1-1.4 1.1-3 0-1-.1-1.8-.4-2.3-.5-1-1.4-1.5-2.7-1.5-.7 0-1.1.1-1.3.3-.3.2-.4.4-.4.8v6.4z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26 11v21H0V0h15v11h11zM4 29.4c.9 0 1.5-.2 1.8-.5.3-.3.5-.9.5-1.8V15.9c0-1-.2-1.6-.6-1.9-.2-.2-.8-.3-1.7-.4V13h8.4c1.8 0 3.2.2 4.3.5 2 .7 3 2 3 3.9 0 1.3-.4 2.4-1.5 3.2-.8.6-1.6 1-2.5 1.1l5.2 7.2.5.4.6.1v.6h-5.3l-5.5-7.9h-.7v5c0 .8.2 1.4.5 1.8.3.3 1 .4 1.8.5v.6H4v-.6z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M26 9h-9V0l9 9z" })
	]
});
export default SvgReferenceProteome;
